import React, { Component } from 'react'
import css from './styles.scss'

import ModifiersEditor from '../ModifiersEditor'

export class GetterEditor extends Component {
  constructor ({ variable }) {
    super()
    this.state = {
      source: variable.args[0] || '',
      keyOrIdx: variable.args[1] || '',
      isVariable: variable.args[2] || false
    }
    this.acceptableMacros = ['javascript', 'choiceFromReference', 'choiceFromAnonymous', 'choiceFromDataSource', 'randomNumber', 'number', 'getter', 'formula']
  }

  handleUpdateSource = evt => {
    this.setState({
      source: evt.target.value
    })
  }

  handleUpdateKeyOrIdx = evt => {
    this.setState({
      keyOrIdx: evt.target.value
    })
  }

  updateIsVariable = evt => {
    this.setState({
      isVariable: evt.target.checked
    })
  }

  handleKeyOrIdx = () => {
    this.setState({
      isVariable: !this.state.isVariable
    })
  }

  componentWillReceiveProps (nextProps) {
    const { report, save, variableName } = this.props
    const { source, keyOrIdx, isVariable } = this.state
    if (nextProps.report === true && report === false) {
      save(variableName, [source, keyOrIdx, isVariable])
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const { update } = this.props
    if (prevState !== this.state) {
      update()
    }
  }

  shouldAutocompleteItemRender = (item, str) => {
    return str.length > 2 && item.label.indexOf(str) === 0
  }

  renderAutocompleteItem = (item, isHighlighted) => {
    return (
      <div className={css.autoEntry} style={{ background: isHighlighted ? 'lightgray' : 'white' }} key={item.label}>
        {item.label} <em className={css.macro}>({item.macro})</em>
      </div>)
  }

  updateAutocompleteValue = evt => {
    this.setState({ keyOrIdx: evt.target.value })
  }

  autcompleteSelected = val => {
    this.setState({
      keyOrIdx: val,
      isVariable: true
    })
  }

  render () {
    let inputDisplay = null
    const varList = []
    const { referenceVariables, vars, variableName, modifiers, instance, instanceModifiers } = this.props
    const { source, keyOrIdx, isVariable } = this.state
    if (isVariable) {
      Object.keys(vars).forEach(varName => {
        if (variableName !== varName) {
          const varDeets = vars[varName]
          if (this.acceptableMacros.indexOf(varDeets.macro) > -1) {
            varList.push(
              <option value={varName} key={varName}>{varDeets.name}</option>
            )
          }
        }
      })
      inputDisplay = (
        <div className={css.fieldset}>
          <label className={css.label}>
            Column Name
            <p className={css.switch}>
              <button onClick={this.handleKeyOrIdx} className={css.switchBtn}>Use a Value</button>
            </p>
            <div className={css.backer}>
              <select
                className={css.select}
                value={keyOrIdx}
                onChange={this.handleUpdateKeyOrIdx}
              >
                <option value=''>Select a variable</option>
                {varList}
              </select>
            </div>
          </label>
        </div>
      )
    } else {
      const variable = vars[keyOrIdx]
      let resolvedName = ''
      if (variable && variable.hasOwnProperty('name')) { // eslint-disable-line no-prototype-builtins
        resolvedName = variable.name
      }
      inputDisplay = (
        <div className={css.fieldset}>
          <label className={css.label}>
            Column Name
            <p className={css.switch}>
              <button onClick={this.handleKeyOrIdx} className={css.switchBtn}>Use a Variable </button>
            </p>
            <input
              className={css.option}
              type='text'
              value={resolvedName || keyOrIdx}
              onChange={this.handleUpdateKeyOrIdx}
            />
          </label>
        </div>
      )
    }
    const sourcesList = referenceVariables.map(variable => (
      <option value={variable} key={variable}>{vars[variable].name}</option>
    ))
    sourcesList.unshift(<option value='' key='EMPTY_OPTION'>Choose...</option>)

    let instanceInput = null
    if (instance) {
      instanceInput = <ModifiersEditor instanceModifiers={instanceModifiers} isInstance />
    }

    return (
      <div>
        <label className={css.label}>
          Source Variable
          <div className={css.backer}>
            <select
              className={css.select}
              value={source}
              onChange={this.handleUpdateSource}
            >
              {sourcesList}
            </select>
          </div>
        </label>
        <div>
          {inputDisplay}
        </div>
        <ModifiersEditor modifiers={modifiers} />
        {instanceInput}
      </div>
    )
  }
}
export default GetterEditor



// WEBPACK FOOTER //
// /app/js/components/EditVariable/GetterEditor/index.js